var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.8,220.2l-21.9-21.9c-14.6-14.6-14.6-38.4,0-53L273.2,10.9c14.6-14.6,38.4-14.6,53,0l21.9,22c14.6,14.6,14.6,38.4,0,53l-134.3,134.3c-14.6,14.6-38.4,14.6-53,0ZM285.3,288.5l-36.8-36.8,131.1-131.1,139.8,139.8-131.1,131.1-36.8-36.8L80,626.3c-18.3,18.3-47.9,18.3-66.3,0-18.4-18.3-18.3-47.9,0-66.3l271.6-271.6ZM419.8,479.2c-14.6-14.6-14.6-38.4,0-53l134.3-134.3c14.6-14.6,38.4-14.6,53,0l21.9,21.9c14.6,14.6,14.6,38.4,0,53l-134.3,134.4c-14.6,14.6-38.4,14.6-53,0l-21.9-21.9h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.be194fea9667fdd89547ce7f8be76ef5.svg";
export { ForwardRef as ReactComponent };